import FileSaver from "file-saver";
import JSZip from "jszip";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import React, { useRef, useState, useEffect } from "react";
import { QRCode } from "react-qrcode-logo";
import { v4 as uuidv4 } from "uuid";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import appUrl from "../../config/appUrl";
export default function GenerateTicketsScreen() {
  const qrCodeRefs = useRef([]);
  const [genrated, setGenerated] = useState(false);
  const [noOfTickets, setNoOfTickets] = useState(1);
  const [uuids, setUuids] = useState([]);
  const [responseData, setResponseData] = useState(null);
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingQr, setLoadingQr] = useState(false);

  const handleGenerateUuids = async (noOfTickets) => {
    if (noOfTickets > 0 && noOfTickets <= 500) {
      const newUuids = [];
      for (let i = 0; i < noOfTickets; i++) {
        newUuids.push({ qrId: uuidv4(), path: "" });
      }
      setGenerated(true);
      setUuids(newUuids);
    } else {
      toast.warn("Number of tickets should be between 1 and 500");
    }
  };

  useEffect(() => {
    if (uuids.length > 0) {
      setDisable(false);
      const newQrCodeRefs = [];
      uuids.forEach((item, index) => {
        newQrCodeRefs[index] = qrCodeRefs.current[index];
      });
      qrCodeRefs.current = newQrCodeRefs;

      const newUuids = [...uuids];
      newUuids.forEach((item, index) => {
        const canvas = qrCodeRefs.current[index].querySelector("canvas");
        const path = canvas.toDataURL("image/png");
        item.path = path;
      });
      setUuids(newUuids);
      setGenerated(false);
    }
  }, [genrated]); // add uuids.length to the dependency array

  const handleDownload = async () => {
    if (noOfTickets <= 0) {
      toast.warn("Number of tickets should be greater than 0");
      return;
    }
    // Send the uuids to the API endpoint
    setDisable(true);
    setLoading(true);
    const response = await fetch(`${appUrl.BASE_URL}QR`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(uuids),
    });

    // Get the response data and save it in state
    const data = await response.json();
    setResponseData(data);

    // Create a new array to store the absolute paths of the images and qrIds
    const imageUrls = [];
    const qrIds = [];

    // Loop through the responseData array and append the server's base URL to the image path
    data.data.forEach((item) => {
      const url = `${appUrl.BASE_URL}${item.path}`;
      imageUrls.push(url);
      qrIds.push(item.qrId);
    });

    // Download the images and Excel file as a zip file
    const zip = new JSZip();
    const folder = zip.folder("images");

    // Create an Excel workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(qrIds.map((qrId) => ({ qrId })));

    imageUrls.forEach((url, index) => {
      // Get the image data using the URL
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          // Create a new file in the zip folder with the image data and name it with the qrId
          folder.file(`${qrIds[index]}.png`, blob);

          // Check if all images have been downloaded and the Excel file has been created, and then download the zip file
          if (index === imageUrls.length - 1) {
            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(wb, ws, "QR IDs");

            // Convert the workbook to a binary string
            const excelData = XLSX.write(wb, {
              bookType: "xlsx",
              type: "binary",
            });

            // Convert the binary string to a Blob
            const excelBlob = new Blob([s2ab(excelData)], {
              type: "application/octet-stream",
            });

            // Create a new file in the zip folder with the Excel data
            folder.file("qrIds.xlsx", excelBlob);

            // Generate the zip file and download it
            zip.generateAsync({ type: "blob" }).then(function (content) {
              saveAs(content, "images.zip");
            });
          }
          setLoading(false);
        })
        .catch((error) => console.log(error));
    });
  };

  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }

  return (
    <>
       <div className="col-12 md:col-6">
            <div className="flex align-items-center">
              <h5
                className="mt-0 text-2xl mb-0 font-semibold text-[#17171B]"
                style={{ color: "#17171B" }}
              >Generate Ticket
              </h5>
            </div>
          </div>
      <div className="card">
   
        <div className="grid p-fluid my-3">
          
          <div className="md:col-4">
            <label className="dBlock fs-16 pb-2">
              <p>Please enter the number of tickets you want to generate</p>
            </label>
            <InputText
              min={1}
              max={500}
              value={noOfTickets}
              onChange={(e) => setNoOfTickets(e.target.value)}
              type="number"
              required
            />
          </div>
          <div className="md:col-8 flex align-items-end justify-content-end">
            <Button
              type="button"
              label="Generate"
              className="btn btn-primary mr-2 Generate_Button"
              onClick={() => handleGenerateUuids(noOfTickets)}
              loading={loadingQr}
            />
            <Button
              type="button"
              label={loading ? "Downloading..." : "Download"}
              className="btn btn-secondary Generate_Button"
              onClick={handleDownload}
              disabled={disable || noOfTickets <= 0}
              icon={
                disable || noOfTickets <= 0 ? "pi pi-ban" : "pi pi-download"
              }
              iconPos="left"
              loading={loading}
              style={{ paddingLeft: "10px" }} // Adjust padding to ensure space between icon and label
            />
          </div>
        </div>

        <div className="grid p-fluid justify-content-center py-4">
          {uuids &&
            uuids.map((item, index) => (
              <div
                key={item.qrId}
                ref={(el) => (qrCodeRefs.current[index] = el)}
              >
                <QRCode value={item.qrId} />
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
